import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core'
import { SelectThemeType, ThemeElementType } from '../types/color-settings.type'

@Directive({
    selector: '[bmTheme]',
    standalone: false
})
export class ThemeDirective implements AfterViewInit {
  @Input('bmTheme') component: SelectThemeType

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostListener('click') onClick() {
    switch (this.component) {
      case 'lang-select':
        this.addThemeClassToMatSelect('document', 'lang')
        break

      case 'find-tracks-select':
        this.addThemeClassToMatSelect('document', 'findTracks')
        break

      case 'confirm-popup-select':
        this.addThemeClassToMatSelect('document', 'confirmPopup')
        break

      case 'color-customizer':
        this.addThemeClassToMatSelect('document', 'colorCustomizer')
        break
    }
  }

  ngAfterViewInit() {
    switch (this.component) {
      case 'lang-select':
        this.addThemeClassToMatSelect('component', 'lang')
        break

      case 'find-tracks-select':
        this.addThemeClassToMatSelect('component', 'findTracks')
        break

      case 'confirm-popup-select':
        this.addThemeClassToMatSelect('component', 'confirmPopup')
        break

      case 'color-customizer':
        this.addThemeClassToMatSelect('component', 'colorCustomizer')
        break

      case 'find-tracks-input':
        this.addThemeClass('component', 'element', '.mdc-notched-outline', 'theme-inputMU__border')
        this.addThemeClass('component', 'element', '.mdc-notched-outline__notch', 'theme-inputMU__borderHover')
        this.addThemeClass('component', 'element', '.mat-mdc-floating-label', 'theme-inputMU__groupName')
        break

      case 'sound-range':
        this.addThemeClass('component', 'element', '.mdc-slider__track--inactive', 'theme-player__soundProgressBar')
        this.addThemeClass('component', 'element', '.mdc-slider__track--active_fill', 'theme-player__soundFilledBar')
        this.addThemeClass('component', 'element', '.mdc-slider__thumb-knob', 'theme-player__soundThumb')
        break
    }
  }

  addThemeClassToMatSelect(el: ThemeElementType, modifier: string) {
    switch (el) {
      case 'component':
        this.addThemeClass('component', 'element', '.mdc-notched-outline', `theme-select__selectBorder--${modifier}`)
        this.addThemeClass(
          'component',
          'element',
          '.mdc-notched-outline__notch',
          `theme-select__selectBorderHover--${modifier}`
        )
        this.addThemeClass(
          'component',
          'element',
          '.mat-mdc-floating-label',
          `theme-select__selectGroupName--${modifier}`
        )
        this.addThemeClass(
          'component',
          'element',
          '.mat-mdc-select-value',
          `theme-select__selectCurrentValue--${modifier}`
        )
        this.addThemeClass('component', 'element', '.mat-mdc-select-arrow', `theme-select__selectArrow--${modifier}`)
        break

      case 'document':
        this.addThemeClass('document', 'nodeList', '.mat-mdc-option', `theme-select__option--${modifier}`)
        this.removeThemeClass(`theme-select__selectedOption--${modifier}`)
        this.addThemeClass('document', 'nodeList', '.mat-mdc-option', `theme-select__hoveredOption-hover--${modifier}`)
        this.addThemeClass('document', 'element', '.mdc-list-item--selected', `theme-select__selectedOption--${modifier}`)
        break
    }
  }

  addThemeClass(el: ThemeElementType, type: 'element' | 'nodeList', childClass: string, themeClass: string) {
    switch (type) {
      case 'element':
        let element
        if (el === 'document') {
          element = document.querySelector(childClass)
        }
        if (el === 'component') {
          element = this.elementRef.nativeElement.querySelector(childClass)
        }
        if (element === null) {
          return
        }
        this.renderer.addClass(element, themeClass)
        break

      case 'nodeList':
        const els = document.querySelectorAll(childClass)
        els.forEach((elm: Element) => {
          this.renderer.addClass(elm, themeClass)
          if (themeClass === 'theme-select__selectedOption--confirmPopup') {
            this.renderer.removeClass(elm, themeClass)
          }
        })
        break
    }
  }

  removeThemeClass(themeClass: string) {
    const els = document.querySelectorAll('.mat-mdc-option')
    els.forEach((elm: Element) => {
      this.renderer.removeClass(elm, themeClass)
    })
  }
}
